import { makeGet, makeGetWithParam } from './ServiceManager';

export const getCanvases = async (createdBy) => {
  const result = createdBy
    ? await makeGetWithParam(
        'service/canvas/canvases',
        null,
        `?created_by=${encodeURIComponent(createdBy)}`
      )
    : await makeGet('service/canvas/canvases');
  return result;
};

export const getCanvas = async (id) => {
  const result = await makeGetWithParam('service/canvas/canvas', null, id);
  return result;
};



// WEBPACK FOOTER //
// ./src/services/CanvasService.js